import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const mediaGallery = document.querySelectorAll('.product-media');
mediaGallery?.forEach((el, index) => {
    const swiperEl = el.querySelector('.swiper');
    const swiperSlides = el.querySelectorAll('.swiper-slide');
    const swiperInstance = new Swiper(swiperEl, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        speed: 450,
        loop: false,
        navigation: {
            prevEl: el.querySelector('.swiper-button-prev'),
            nextEl: el.querySelector('.swiper-button-next'),
        },
        pagination: {
            el: ".swiper-pagination"
        }
    });
    document.addEventListener('variantChanged', (e) => {
        const variantId = e.detail;
        const media = document.querySelector([`[data-for="${variantId}"]`]);
        if (media) {
            swiperInstance.slideTo([...swiperSlides].indexOf(media));
        }
    });
});
